module.exports = __webpack_public_path__ + "img/914294478.fe4bbc86.jpg";